import { useState, useRef } from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import posService from "../../services/pos/pos.service";

interface AddProductProps {
  posId: number[];
  onSuccess?: () => void; // optional success callback
}

const AddProducttopos: React.FC<AddProductProps> = ({ posId, onSuccess }) => {

  const toast = useRef<Toast>(null);
  const [products, setProducts] = useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const [safetyStock, setSafetyStock] = useState<number>(0);
  const [reorderStock, setReorderStock] = useState<number>(0);
  const [productsLoaded, setProductsLoaded] = useState(false);

   const handleProductChange = (e: DropdownChangeEvent) => {
    setSelectedProduct(e.value);
  };

  const handleDropdownShow = () => {

  if (posId && !productsLoaded) {
    posService.remaingposproducts(posId)
      .then((res: any[]) => {
        setProducts(res || []);
        setProductsLoaded(true); // to avoid reloading
      })
      .catch(() =>
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load products",
        })
      );
  }
};

  const handleAddProduct = async () => {
    if (!selectedProduct || safetyStock < 0 || reorderStock < 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Select a Product",
      });
      return;
    }
    const payload = {
      productId: selectedProduct.productId,
      measurementTypeId: selectedProduct.measurementTypeId,
      posId: posId,
      safetyStock,
      reorderStock,
    };

    try {
      const res = await posService.AddPosProducts(payload);
      if (res?.isSuccess) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Product added successfully",
        });
        if (onSuccess) onSuccess(); 
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: res?.message || "Failed to add product",
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while adding the product",
      });
    }
  };

  return (
    <div className="p-fluid">
      <Toast ref={toast} />
      <h4 className="mb-3">Add Product to POS</h4>

      <Dropdown
        value={selectedProduct}
        options={products}
        onChange={handleProductChange}
        onShow={handleDropdownShow} // Load when opened
        filter
        optionLabel="productName"
        placeholder="Select Product"
        className="mb-3"
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
      />

      <InputText
        placeholder="Safety Stock"
        type="number"
        min="0"
        keyfilter="pnum"
        onChange={(e) => setSafetyStock(Number(e.target.value))}
        className="mb-3"
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
      />

      <InputText
        placeholder="Reorder Stock"
        type="number"
        min="0"
        keyfilter="pnum"
        onChange={(e) => setReorderStock(Number(e.target.value))}
        className="mb-3"
        style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
      />

      <Button label="Add Product" onClick={handleAddProduct} />
    </div>
  );
};

export default AddProducttopos;
